import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card } from '../components/ui/Card';
import { IdCardIcon, UploadIcon, CheckCircleIcon, AlertCircleIcon, DownloadIcon, ClockIcon } from 'lucide-react';
export function NinPrinting() {
  return <div data-id="element-435">
      <PageHeader title="NIN Virtual Card" description="Generate a virtual version of your National Identification Number" data-id="element-436" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-437">
        <div className="lg:col-span-2" data-id="element-438">
          <Card title="NIN Virtual Card Service" data-id="element-439">
            <div className="mb-6" data-id="element-440">
              <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-6" data-id="element-441">
                <div className="flex" data-id="element-442">
                  <div className="flex-shrink-0" data-id="element-443">
                    <AlertCircleIcon className="h-5 w-5 text-blue-400" data-id="element-444" />
                  </div>
                  <div className="ml-3" data-id="element-445">
                    <h3 className="text-sm font-medium text-blue-800" data-id="element-446">
                      Information
                    </h3>
                    <div className="mt-2 text-sm text-blue-700" data-id="element-447">
                      <p data-id="element-448">
                        Oxy Pay allows you to generate a virtual version of your
                        NIN card. Simply provide your NIN number, and we'll
                        create a downloadable digital version that you can use
                        for online verification.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="space-y-6" data-id="element-449">
                <div data-id="element-450">
                  <h3 className="text-lg font-medium" data-id="element-451">
                    Benefits of Virtual NIN
                  </h3>
                  <ul className="mt-2 list-disc pl-5 text-sm text-gray-600 space-y-1" data-id="element-452">
                    <li data-id="element-453">Always accessible on your phone or computer</li>
                    <li data-id="element-454">No risk of physical card damage or loss</li>
                    <li data-id="element-455">Easy to share for verification purposes</li>
                    <li data-id="element-456">
                      Instant generation - no waiting for physical delivery
                    </li>
                    <li data-id="element-457">Environmentally friendly digital alternative</li>
                  </ul>
                </div>
                <div data-id="element-458">
                  <h3 className="text-lg font-medium" data-id="element-459">Process</h3>
                  <ol className="mt-2 list-decimal pl-5 text-sm text-gray-600 space-y-3" data-id="element-460">
                    <li data-id="element-461">
                      <p className="font-medium" data-id="element-462">Enter your NIN</p>
                      <p className="text-gray-500" data-id="element-463">
                        Provide your 11-digit National Identification Number.
                      </p>
                    </li>
                    <li data-id="element-464">
                      <p className="font-medium" data-id="element-465">Verify your identity</p>
                      <p className="text-gray-500" data-id="element-466">
                        We'll verify your details with the national database.
                      </p>
                    </li>
                    <li data-id="element-467">
                      <p className="font-medium" data-id="element-468">
                        Generate your virtual NIN card
                      </p>
                      <p className="text-gray-500" data-id="element-469">
                        Our system creates a digital version of your NIN card.
                      </p>
                    </li>
                    <li data-id="element-470">
                      <p className="font-medium" data-id="element-471">Download your virtual card</p>
                      <p className="text-gray-500" data-id="element-472">
                        Download your virtual NIN card as a PDF file.
                      </p>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div data-id="element-473">
          <Card title="Generate Virtual NIN" data-id="element-474">
            <form className="space-y-4" data-id="element-475">
              <div data-id="element-476">
                <label htmlFor="nin" className="block text-sm font-medium text-gray-700" data-id="element-477">
                  Your NIN Number
                </label>
                <input type="text" name="nin" id="nin" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Enter your 11-digit NIN" data-id="element-478" />
              </div>
              <div data-id="element-479">
                <label htmlFor="fullName" className="block text-sm font-medium text-gray-700" data-id="element-480">
                  Full Name
                </label>
                <input type="text" name="fullName" id="fullName" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Enter your full name" data-id="element-481" />
              </div>
              <div data-id="element-482">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-483">
                  Phone Number
                </label>
                <input type="text" name="phone" id="phone" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Enter your phone number" data-id="element-484" />
              </div>
              <div data-id="element-485">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-486">
                  Email Address
                </label>
                <input type="email" name="email" id="email" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Enter your email" data-id="element-487" />
              </div>
              <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-488">
                <IdCardIcon className="mr-2 h-5 w-5" data-id="element-489" />
                Generate Virtual NIN
              </button>
            </form>
          </Card>
          <Card title="Your Virtual NIN Cards" className="mt-6" data-id="element-490">
            <div className="space-y-4" data-id="element-491">
              <div className="border rounded-lg p-4" data-id="element-492">
                <div className="flex justify-between items-center" data-id="element-493">
                  <div data-id="element-494">
                    <p className="font-medium" data-id="element-495">NIN Virtual Card</p>
                    <p className="text-xs text-gray-500 flex items-center mt-1" data-id="element-496">
                      <ClockIcon className="h-3 w-3 mr-1" data-id="element-497" /> Generated Jul 15,
                      2023
                    </p>
                  </div>
                  <button className="p-2 bg-blue-100 rounded-full text-blue-600" data-id="element-498">
                    <DownloadIcon className="h-5 w-5" data-id="element-499" />
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-center p-4 border-t border-gray-200 pt-4" data-id="element-500">
                <div className="text-center" data-id="element-501">
                  <p className="text-sm text-gray-500" data-id="element-502">
                    Your generated virtual NIN cards will appear here.
                  </p>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}